<div class="link-field-container">
  <div class="link-info">
    <span>{{ display | displayTranslation }} ({{ elementId }})</span>
    <fa-icon icon="arrow-right" class="arrow-icon"></fa-icon>
    <span *ngIf="parentProfile" class="child-badge">{{
      parentProfile.getDisplay() | displayTranslation
    }}</span>
    <ng-container *ngIf="filterChips">
      <num-filter-chips
        [displayBlockTriangle]="false"
        [filterChips]="filterChips"
      ></num-filter-chips>
    </ng-container>
    <span *ngIf="unlinkedRequiredOrRecommendedReferences" class="warning-badge"
      >{{ 'SHARED_COMPONENTS.REFERENCE_TILE.NOTLINKED' | translate }}
    </span>
  </div>

  <mat-checkbox
    *ngIf="referenceField"
    [checked]="referenceField.getMustHave()"
    (change)="setMustHave($event.checked)"
  >
    {{ 'SHARED_COMPONENTS.REFERENCE_TILE.REQUIRED' | translate }}
  </mat-checkbox>
  <div class="actions" (click)="deleteReferenceLink()">
    {{ 'SHARED_COMPONENTS.REFERENCE_TILE.DELETE' | translate }}
    <fa-icon class="icon" icon="trash" size="lg"></fa-icon>
    <!--<num-button type="blue" (click)="navigateToProfile()">bearbeiten</num-button>-->
  </div>
</div>
